<div class="change-leave-type-actuation">
    <h2 matDialogTitle class="m-b-15">Cambiar tipo de baja</h2>

    <div mat-dialog-content class="m-t-10" *ngIf="leaveInfo">
        <div class="form" role="form" autocomplete="off">
            <div class="form-wrp">
                <div class="card-actuation header-actuation your-account m-b-6">
                    <div class="inner-card m-b-5">
                        <form [formGroup]="form">
                            <mat-form-field class="m-r-20 leave-type-input" floatLabel="always">
                                <mat-label>Tipo de baja</mat-label>
                                <mat-select formControlName="leaveType">
                                    <mat-option *ngFor="let type of leaveTypes" [value]="type.value">
                                        {{type.label}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="form.get('leaveType').invalid && form.get('leaveType').touched">
                                    <span *ngIf="form.get('leaveType').errors.required" class="validation-span">
                                        Obligatorio
                                    </span>
                                </mat-error>
                            </mat-form-field>
                        </form>
                    </div>
                </div>

                <ng-container *ngIf="!leaveInfo.falta">
                    <visit-pending-task [LeaveId]="data.leaveId" [(PendingTasks)]="pendingTasks">
                    </visit-pending-task>

                    <app-task-creation-card *ngIf="selectedLeaveType?.managed" id="task-creation-card"
                        [LeaveId]="data.leaveId" [EmployeeId]="data.employeeId">
                    </app-task-creation-card>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="text-a-r p-t-10">
        <button (click)="onSubmit()" class="m-r-15" mat-raised-button color="accent">Aceptar</button>
        <button (click)="close()" mat-raised-button color="warn">Cancelar</button>
    </div>
</div>